<template>
  <transition
    v-on:before-enter="beforeEnterContainer"
    v-on:enter="enterContainer"
    v-bind:css="false"
  >
    <div class="logo-container" ref="logoContainer">
      <img class="logo" src="../assets/img/logo.png">
      <transition v-on:before-enter="beforeEnter" v-on:enter="enter" v-bind:css="false">
        <div class="home-linea-chica" v-if="mounted"></div>
      </transition>
      <p class="logo-frase">Development
        <br>Company
      </p>
    </div>
  </transition>
</template>

<script>
import Vue from "vue";

window.Event = new Vue();
export default {
  name: "logo",
  data() {
    return {
      mounted: false
    };
  },
  mounted() {
    this.mounted = true;
  },
  created() {
    Event.$on("linea-grande-completed", () =>
      this.enterContainer(this.$refs.logoContainer)
    );
  },
  methods: {
    beforeEnter: function(el) {
      el.style.top = "-29vw";
    },
    enter: function(el, done) {
      Velocity(el, { top: "2vh" }, { duration: 1000 });
      Velocity(el, {
        complete: function() {
          Event.$emit("linea-chica-completed");
        }
      });
    },
    beforeEnterContainer: function(el) {
      el.style.top = "45vh";
    },
    enterContainer: function(el) {
      Velocity(el, { top: "5.4vh" }, { duration: 1000 });
      Velocity(el, {
        complete: function() {
          Event.$emit("logo-container-completed");
        }
      });
    }
  }
};
</script>
